import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  usageTitle: {
    id: 'frontbucket.pipelines.usage.title',
    description: 'The title of the pipelines usage section',
    defaultMessage: 'Pipelines usage',
  },
  includedMinutesUsed: {
    id: 'frontbucket.pipelines.usage.includedMinutesUsed',
    description:
      'Text describing included minutes used in this period. The usage value is wrapped in <bold> tags so it can be visually emphasised.',
    defaultMessage: '<bold>{usage}</bold> included minutes used this period.',
  },
  minutesUsed: {
    id: 'frontbucket.pipelines.usage.minutesUsed',
    description:
      'Text describing total minutes used in this billing period. The usage value is wrapped in <bold> tags so it can be visually emphasised.',
    defaultMessage: '<bold>{usage}</bold> minutes used this billing period.',
  },
  freeMinutesUsed: {
    id: 'frontbucket.pipelines.usage.freeMinutesUsed',
    description:
      'Text describing total free minutes used as part of marketing promotion. Both the usage value and the free allowance are wrapped in <bold> tags so they can be visually emphasised.',
    defaultMessage:
      '<bold>{usage}</bold> minutes used of <bold>{freeAllowance}</bold> free minutes.',
  },
  limitedFreeMinutesUsed: {
    id: 'frontbucket.pipelines.usage.limitedFreeMinutesUsed',
    description:
      'Text describing total free minutes used as part of marketing promotion. The usage value is wrapped in <bold> tags so it can be visually emphasised.',
    defaultMessage: '<bold>{usage}</bold> free minutes used this period.',
  },
  usageResetDate: {
    id: 'frontbucket.pipelines.usage.resetDate',
    description: 'Text indicating when the usage will reset',
    defaultMessage: 'Your usage will reset on {resetDate}.',
  },
  usageLimitedInfo: {
    id: 'frontbucket.pipelines.usage.limitedInfo',
    description: 'Information about limited pipeline usage',
    defaultMessage:
      'Pipelines will stop running once all minutes are used unless you update your billing details.',
  },
  viewPlanDetails: {
    id: 'frontbucket.pipelines.usage.viewPlanDetails',
    description: 'Link text for viewing plan details',
    defaultMessage: 'View plan details',
  },
  needMoreMinutes: {
    id: 'frontbucket.pipelines.usage.needMoreMinutes',
    description: 'Text for needing more pipeline minutes',
    defaultMessage: 'Need more Pipelines minutes?',
  },
  upgradeDescription: {
    id: 'frontbucket.pipelines.usage.upgradeDescription',
    description: 'Description of upgrade benefits',
    defaultMessage:
      'Upgrade for more minutes – plus advanced admin controls and greater security features.',
  },
  upgradeButton: {
    id: 'frontbucket.pipelines.usage.upgradeButton',
    description: 'Text for the upgrade button',
    defaultMessage: 'Upgrade',
  },
  usageButton: {
    id: 'frontbucket.pipelines.usage.usageButton',
    description: 'Text for the usage button',
    defaultMessage: 'Usage',
  },
});
